import { Col, Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import LoadingButton from "../../components/Loading/LoadingButton";
import usePDFDownload from "../../hooks/usePDFDownload";

const EnterSMSFactor = ({ id }) => {
  const {
    handleSubmit,
    register,
    formState: { errors },
  } = useForm();

  const { mutate, isPending } = usePDFDownload({
    url: "/totalpost/v1/getFactorByCode",
  });

  return (
    <form
      onSubmit={handleSubmit(({ code }) => {
        mutate({ code, id });
      })}
    >
      <Form.Label htmlFor="print-factor-button-code">
        <h6>لطفا کد پیامک شده را وارد نمایید:</h6>
      </Form.Label>

      <div className="d-flex flex-wrap">
        <Col xs={12} lg={9}>
          <Form.Control
            type="text"
            id="print-factor-button-code"
            className="rounded-0"
            {...register("code", {
              required: { value: true, message: "کد الزامی" },
              minLength: {
                value: 6,
                message: "کد ورودی باید 6 رقم باشد",
              },
              maxLength: {
                value: 6,
                message: "کد ورودی باید 6 رقم باشد",
              },
            })}
          />
          {errors.code && (
            <p className="fs-small text-danger">{errors.code.message}</p>
          )}
        </Col>
        <Col xs={12} lg={3}>
          {isPending && (
            <LoadingButton
              className="btn-success-style w-100 rounded-0"
              center
              title="در حال دریافت"
            />
          )}
          {!isPending && (
            <button className="btn-success-style w-100 rounded-0">
              دانلود فاکتور
            </button>
          )}
        </Col>
      </div>
    </form>
  );
};

export default EnterSMSFactor;
